import React from 'react';
import {AiFillBehanceCircle} from 'react-icons/ai';
import {AiOutlineGithub} from 'react-icons/ai';
import {BsLinkedin} from 'react-icons/bs';
import { FaBehance } from 'react-icons/fa';
import { FiGithub } from 'react-icons/fi';
import { FiLinkedin } from 'react-icons/fi';


const HeaderSocials = () => {
  return (
    <div className='header__socials'> 
        <a href = "https://www.behance.net/eltonajadi" target="_blank"> <FaBehance /> </a>
        <a href = "https://github.com/eltonalexanderajadi" target="_blank">  <FiGithub /> </a>
        <a href = "https://www.linkedin.com/in/elton-alexander-ajadi-a55137239/" target="_blank"> <FiLinkedin /> </a>
    </div>
  )
}

export default HeaderSocials